import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить список бонусов
  async loadBonuses ({ commit }) {
    var data=null;
    try{
      data = await api.Get("BonusService/Bonus");
      commit('loadBonuses', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

    // Загрузить список типов бонусов
    async loadBonusPackages ({ commit }) {
        var data=null;
        try{
            data = await api.Get("BonusService/BonusPacket");
            commit('loadBonusPackages', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

// Загрузить список типов партнеров
  async loadPartnerTypes ({ commit }) {
    var data=null;
    try{
      data = await api.Get("DirectoryService/PartnerType");
      commit('loadPartnerTypes', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


  //добавить
  async addBonus({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("BonusService/Bonus", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("BonusService/Bonus/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addBonus', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать
  async editBonus({commit}, data) {
    var newData = null;
    try {
      await api.Put("BonusService/Bonus", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("BonusService/Bonus/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editBonus', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить
  async deleteBonus({commit}, Id) {
    try {
      var getparams = '?BonusId=' + Id;
      await api.Delete("BonusService/Bonus", getparams);
      commit('deleteBonus',Id);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },



}
